export const getTimeFromTimestamp = (timestamp) => {
  const time = new Date(timestamp).toLocaleString([], {
    hour: 'numeric',
    minute: 'numeric',
  });
  return time;
};
